import React, { useState } from "react";
import axios from "axios";
import API from "../api";
import './edpinteractivo.css'; // 👈 Asegúrate de que el archivo esté en la misma carpeta

const EDPInteractivo = () => {
  const [encabezado, setEncabezado] = useState({
    subcontratista: "",
    empresa: "",
    obra: "",
    contrato: "",
    pago: "Pago a 30 días",
    estadoPago: "1",
    avanceObras: "107,0%",
    fecha: "",
    numeroEstadoPago: 1,
  });

  const [items, setItems] = useState([
    {
      item: "1",
      designacion: "GRAVILLA",
      unidad: "M3",
      cantidadContrato: 108,
      precioUnitario: 15000,
      totalContrato: 108 * 15000,
      cantidadEjecutado: 106,
      totalEjecutado: 106 * 15000,
      cantidadAnterior: 0,
      totalAnterior: 0,
      cantidadMensual: 106,
      totalMensual: 106 * 15000,
    },
  ]);

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = field.includes("cantidad") || field.includes("precioUnitario")
      ? parseFloat(value || 0)
      : value;

    const i = newItems[index];
    i.totalContrato = i.cantidadContrato * i.precioUnitario;
    i.totalEjecutado = i.cantidadEjecutado * i.precioUnitario;
    i.totalAnterior = i.cantidadAnterior * i.precioUnitario;
    i.totalMensual = i.cantidadMensual * i.precioUnitario;

    setItems(newItems);
  };

  const addFila = () => {
    setItems([
      ...items,
      {
        item: `${items.length + 1}`,
        designacion: "",
        unidad: "",
        cantidadContrato: 0,
        precioUnitario: 0,
        totalContrato: 0,
        cantidadEjecutado: 0,
        totalEjecutado: 0,
        cantidadAnterior: 0,
        totalAnterior: 0,
        cantidadMensual: 0,
        totalMensual: 0,
      },
    ]);
  };

  const calcularTotales = () => {
    const valorNeto = items.reduce((sum, i) => sum + i.totalMensual, 0);
    const iva = valorNeto * 0.19;
    const total = valorNeto + iva;
    return { valorNeto, iva, total };
  };

  const guardarEDP = async () => {
    const totales = calcularTotales();
    try {
      await axios.post(`${API}/edp-completo`, {
        encabezado,
        items,
        totales: {
          valorNeto: Math.round(totales.valorNeto),
          iva: Math.round(totales.iva),
          total: Math.round(totales.total),
          porcentajeAvance: encabezado.avanceObras,
        },
      });
      alert("✅ EDP guardado correctamente");
    } catch (err) {
      console.error(err);
      alert("❌ Error al guardar");
    }
  };

  const { valorNeto, iva, total } = calcularTotales();

  return (
    <div className="edp-container">
      <h2 className="edp-titulo">📋 Resumen Estado de Pago</h2>

      <div className="edp-form">
        {Object.keys(encabezado).map((key) => (
          <div key={key} className="edp-form-group">
            <label>{key.toUpperCase()}</label>
            <input
              type="text"
              value={encabezado[key]}
              onChange={(e) => setEncabezado({ ...encabezado, [key]: e.target.value })}
            />
          </div>
        ))}
      </div>

      <div className="edp-tabla-wrapper">
        <table className="edp-tabla">
          <thead>
            <tr>
              <th>Item</th>
              <th>Designación</th>
              <th>Unid.</th>
              <th>Cant. Contrato</th>
              <th>P.U.</th>
              <th>Total Contrato</th>
              <th>Ejecutado</th>
              <th>Total Ejecutado</th>
              <th>Anterior</th>
              <th>Total Anterior</th>
              <th>Mensual</th>
              <th>Total Mensual</th>
            </tr>
          </thead>
          <tbody>
            {items.map((fila, index) => (
              <tr key={index}>
                {Object.keys(fila).map((key) => (
                  <td key={key}>
                    {key.includes("total") || key === "item" ? (
                      Math.round(fila[key])
                    ) : (
                      <input
                        type="text"
                        value={fila[key]}
                        onChange={(e) => handleItemChange(index, key, e.target.value)}
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button className="btn-agregar" onClick={addFila}>➕ Agregar fila</button>

      <div className="edp-totales">
        <p><strong>Valor Neto:</strong> ${valorNeto.toLocaleString()}</p>
        <p><strong>IVA (19%):</strong> ${iva.toLocaleString()}</p>
        <p><strong>TOTAL:</strong> ${total.toLocaleString()}</p>
      </div>

      <button className="btn-guardar" onClick={guardarEDP}>
        💾 Guardar Estado de Pago
      </button>
    </div>
  );
};

export default EDPInteractivo;
